<template>
    <div v-if="!done && p1 && p2" class="swiss">
      <div class="swiss__body">
        <div class="swiss__item swiss__item--first" :class="{ 'swiss__item--hot': current_answer === 1 }" @click="vote(1)">
          <div :style="{ backgroundImage: `url('${p1.data.thumbnail}')` }"></div>
        </div>
        <div class="swiss__item swiss__item--second" :class="{ 'swiss__item--hot': current_answer === 2 }" @click="vote(2)">
          <div :style="{ backgroundImage: `url('${p2.data.thumbnail}')` }"></div>
        </div>

      </div>
      <h1 class="swiss__description">
          Please choose the statement or image that is 'more true' or 'more compelling' even if the images or concepts seem unrelated.
      </h1>

    </div>
</template>
<script>
import { Scene } from '@src/utils/swiss';

export default {
  props: {
    questions: {
      type: Array,
      default: ()=>{}
    },
  },
  data() {
    return {
      done: false,
      p1: false,
      p2: false,
      round: 0,
      scene: null,
      next_pair: null,
      current_answer: null,
    };
  },
  mounted() {
    this.$nextTick(function () {
      if (this.questions.length) {
        console.log(this.questions);
        this.scene = new Scene(this.questions);
        this.getNextMatch();
      }
    });
  },
  methods: {
    activate(questions) {
      this.scene = new Scene(questions);
      this.getNextMatch();
    },
    vote(answer) {
      if (this.current_answer) {
        return;
      }

      this.current_answer = answer;

      if (answer === 1) {
        this.scene.addMatch(this.p1, this.p2, 'win');
      } else {
        this.scene.addMatch(this.p1, this.p2, 'loose');
      }

      setTimeout(() => {
        this.current_answer = null;
        this.getNextMatch();
      }, 250);
    },
    getNextMatch() {
      const data = this.scene.nextMatch();

      if (data) {
        this.p1 = data.p1;
        this.p2 = data.p2;
        this.round = this.scene.round;
      } else {
        const result = this.scene.getResults();
        console.log(result);
        this.$emit('swiss_done', result);
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .swiss {
    display: flex;
    flex-direction: column;
    align-items: center;
    width:100%;
    max-width: 90%;
    height: 100%;
    margin: 0 auto;
    transition: 1sec;

      @media (max-width: 767px) {
        max-width: 95%;
        min-height: 100%;
      }


    &__description {
      flex-grow: 0;
      width: 100%;
      font-size: 18px;
      text-align: center;

      @media (max-width: 767px) {
        font-size: 14px;
      }

    }

    &__body {
      display: flex;
      flex-direction: row;
      flex-grow: 1;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      transition: 1sec;

      @media (max-width: 767px) {
        flex-direction: column;
      }
    }

    &__item {
      display: flex;
      flex: 1;
      width: 100%;
      min-height: 100%;
      padding: 10px;
      margin: 10px;
      cursor: pointer;
      border: 1px solid white;
      transition: border-color 0.2s linear;

      @media (max-width: 767px) {
        flex-direction: column;
        min-height: 100px;
      }

      &--hot {
        text-decoration: none;
        background-color: rgba(255, 145, 0, 0.021);
        border-color: #f5ac49;
        animation-name: flash;
        animation-duration: 0.5s;
        animation-timing-function: linear;
      }

      @media (hover: hover) {
        &:hover {
          background-color: rgba(255, 145, 0, 0.021);
          border-color: #f5ac49;
        }
      }

      & div {
        flex: 1;
        min-width: 100%;
        min-height: 100%;
        background-repeat:   no-repeat;
        background-position: center center;
        background-size:     contain;                      /* <------ */
      }

      &--first {
        text-align: right;
      }
      &--second {
        text-align: left;
      }
    }
}
</style>
